<script setup lang="ts">
interface PropsInterface {
  className?: string;
  contentClassName?: string;
  title?: string;
  saveDisabled?: boolean;
  dirty: boolean;
  cancel: () => void;
  save: () => void;
}

const props = defineProps<PropsInterface>();
</script>

<template>
  <Card class="form-card p-fluid" :class="[className, { editing: dirty }]">
    <template v-if="props.title" #header>
      <h2>{{ title }}</h2>
    </template>
    <template #content>
      <slot name="form" />
    </template>
    <template #footer>
      <template v-if="props.dirty">
        <AppButton id="cancel_btn" type="secondary" text="Cancel" @click="cancel" />
        <AppButton id="save_btn" type="primary" text="Save" :disabled="!!props.saveDisabled" @click="save" />
      </template>
    </template>
  </Card>
</template>

<style lang="scss" scoped>
.form-card {
  border: 3px solid #ffffff;
  display: flex;
  flex-direction: column;
  :deep(.p-card-body) {
    flex: 1;
    display: flex;
    flex-direction: column;
    .p-card-content {
      flex: 1;
    }
  }
  :deep(.p-card-footer) {
    min-height: 72px;
    border-radius: 0 0 13px 13px;
    justify-content: flex-end;
    padding: 0;
    align-items: center;

    .save {
      width: 65px;
      margin: 0 12px;
    }
  }
  &.editing {
    border-color: var(--primary-color-medium);

    :deep(.p-card-body) {
      .p-card-footer {
        display: flex;
        background-color: var(--primary-color-light);

        button:last-of-type {
          margin: 0 12px;
        }
      }
    }
  }
}
</style>
